import liff from '@line/liff'
import { Languages } from '@liff/i18n/lib/types'

export const LiffSDK = {
  init() {
    return liff.init({ liffId: import.meta.env.VITE_LIFF_ID || '' })
  },
  login(redirectUri?: string) {
    return liff.login({ redirectUri })
  },
  logout() {
    return liff.logout()
  },
  isLoggedIn() {
    return liff.isLoggedIn()
  },
  isInClient() {
    return liff.isInClient()
  },
  getLanguage() {
    return liff.getLanguage()
  },
  setLanguage(lang: Languages) {
    return liff.i18n.setLang(lang)
  },
}
